import styled from '@emotion/styled';

import { forDesktop, forMobile, Typography } from '@/design-system';
import { typographyVariantStyles } from '@/design-system/typography-variants';

export const SummaryGrid = styled('section')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: theme.spacing[16],

  [forMobile]: { gap: theme.spacing[8] },
}));

export const SummaryCard = styled('article')(({ theme }) => ({
  display: 'flex',
  minHeight: 88,
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing[8],
  padding: theme.spacing[16],
  border: `1px solid ${theme.colors.border.default}`,
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.canvas,
  fontVariantNumeric: 'tabular-nums',

  [forDesktop]: {
    minHeight: 'auto',
    gap: theme.spacing[16],
    padding: theme.spacing[24],
  },
}));

const { fontSize, fontWeight, lineHeight } = typographyVariantStyles.h5;

export const SummaryValue = styled(Typography)({
  [forDesktop]: { fontSize, fontWeight, lineHeight },
});
